module.exports = __webpack_public_path__ + "static/media/A6CB1E7A-9F12-4F7B-9AF8-E37350BBFFC9.bc373c53.JPG";